export enum SubscriptionStatusUiEnum {
  active = 'active',
  cancelled = 'cancelled',
  canceling = 'canceling',
  completed = 'completed',
}
